import * as React from 'react';
import { BaseDateInput } from './BaseDateInput';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { TimeInput } from './TimeInput';
import { DATE_TIME_WRAPPER } from '../common/classes';
import { useEffect, useState } from 'react';
import { getJavaDateTime } from '@mc/react-format';
import { parseISO } from 'date-fns';
import { isDateChanged, isTimeChanged } from './utils';

export type DateInputProps = Omit<
  React.ComponentProps<typeof BaseDateInput>,
  'showTime' | 'monthPicker' | 'convertValue' | 'fullWidth'
>;

export const DateTimeInput: React.FC<DateInputProps> = ({
  className,
  dataTest,
  autoFocus,
  value,
  placeholder,
  addonAfter,
  onChange,
  onBlur,
  ...other
}) => {
  const [day, setDay] = useState<string | undefined>(value);
  const [time, setTime] = useState<string | undefined>(value);

  useEffect(() => {
    setDay(value);
    setTime(value);
  }, [value]);

  return (
    <div className={classNames(className, DATE_TIME_WRAPPER)}>
      <BaseDateInput
        value={day}
        {...other}
        dataTest={dataTest}
        className={classNames(
          className,
          Classes.DATE_TIME_INPUT,
          Classes.STRING_DATE_TIME_INPUT
        )}
        placeholder={placeholder}
        onChange={(newValue) => {
          setDay(newValue);
        }}
        onBlur={(newValue) => {
          if (onChange) {
            if (newValue) {
              const dayDate = parseISO(newValue);
              if (isDateChanged(dayDate, value)) {
                //pokud se změnilo datum
                if (time) {
                  const timeDate = parseISO(time);
                  dayDate.setHours(
                    timeDate.getHours(),
                    timeDate.getMinutes(),
                    timeDate.getSeconds(),
                    timeDate.getMilliseconds()
                  );
                }
                const newDate = getJavaDateTime(dayDate);
                onChange(newDate!);
                onBlur?.(newDate!);
              }
            } else {
              if (value) {
                //promazání data POUZE pokud bylo něco vyplněno
                onChange(undefined);
                setDay(undefined);
                onBlur?.(undefined);
              }
            }
          }
        }}
        showTime={false}
        autoFocus={autoFocus}
      />
      <TimeInput
        value={time}
        {...other}
        addonAfter={addonAfter}
        onChange={(newValue) => {
          setTime(newValue);
        }}
        onBlur={(newTime, isValid) => {
          if (onChange) {
            if (newTime) {
              const timeDate = parseISO(newTime);

              if (isTimeChanged(timeDate, value)) {
                //pokud se změnil čas
                if (day) {
                  //pokud je už vyplněno datum, doplní se čas
                  const dayDate = parseISO(day);
                  timeDate.setFullYear(
                    dayDate.getFullYear(),
                    dayDate.getMonth(),
                    dayDate.getDate()
                  );
                }
                const newDate = getJavaDateTime(timeDate);
                onChange(newDate!);
                onBlur?.(newDate!);
              }
            } else if (isValid) {
              //pokud není vyplněno a je validní
              //tj. byl odmazán čas
              if (value) {
                //promazání data POUZE pokud bylo něco vyplněno
                onChange(undefined);
                setTime(undefined);
                onBlur?.(undefined);
              }
            } else {
              //pokud není vyplněno a je invalidní
              //tj. byla napsaná konina
              onChange(day);
              setTime(day);
              onBlur?.(day);
            }
          }
        }}
      />
    </div>
  );
};
